import React from "react";

const TopCurve = ({ fill, className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 1440 62"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 35.9999C0 35.9999 306 0.00012207 732 0C1158 -0.00012207 1440 35.9999 1440 35.9999V61.9999H0V35.9999Z"
        fill={fill}
      />
    </svg>
  );
};

export default TopCurve;
